import Vue from 'vue';
import { handlerResponse } from '@/helpers/commonHelpers';

export default {
  namespaced: true,
  state: {
    currencies: [],
    packageTypes: [],
    incoterms: [],
    shapeType: [],
    notificationsCount: null,
    packetsGridTemplates: [],
    operationsGridTemplates: [],
    invoicesGridTemplates: [],
    vat: [],
    humidityList: [],
    commissionTypes: [],
    rawDistributionGridTemplates: [],
    languages: [],
    currentRoutePermissions: {},
    permissionsList: {},
    invoiceVats: [],
    componentsVersions: {},
    instances_types: []
  },
  getters: {
    currencies(state) {
      return state.currencies;
    },
    packageTypes(state) {
      return state.packageTypes;
    },
    incoterms(state) {
      return state.incoterms;
    },
    notificationsCount(state) {
      return state.notificationsCount;
    },
    shapeType(state) {
      return state.shapeType;
    },
    packetsGridTemplates(state) {
      return state.packetsGridTemplates;
    },
    vat(state) {
      return state.vat;
    },
    humidityList(state) {
      return state.humidityList;
    },
    commissionTypes(state) {
      return state.commissionTypes;
    },
    permissionsList(state) {
      return state.permissionsList;
    }
  },
  mutations: {
    getCurrencies(state, payLoad) {
      const unicodeCurrencyMap = {
        'DKK': '&#107;&#114;',
        'EUR': '&#8364;',
        'GBP': '&#163;',
        'USD': '&#36;'
      };
      state.currencies = payLoad.map((item) => {
        item.unicodeSymbol = unicodeCurrencyMap[item.code] || '';
        return item;
      });
    },
    setPackageTypes(state, data) {
      state.packageTypes = data;
    },
    setIncoterms(state, data) {
      state.incoterms = data;
    },
    setNotificationsCount(state, data) {
      state.notificationsCount = data;
    },
    setShapeType(state, data) {
      state.shapeType = data;
    },
    setPacketsGridTemplates(state, payLoad) {
      state.packetsGridTemplates = payLoad;
    },
    setOperationsGridTemplates(state, payload) {
      state.operationsGridTemplates = payload;
    },
    setVat(state, data) {
      state.vat = data;
    },
    setHumidityList(state, data) {
      state.humidityList = data;
    },
    setCommissionTypes(state, data) {
      state.commissionTypes = data;
    },
    setRawDistributionGridTemplates(state, data) {
      state.rawDistributionGridTemplates = data;
    },
    setLanguages(state, data) {
      state.languages = data;
    },
    setUserPermissions(state, data) {
      state.permissionsList = data;
    },
    setCurrentRoutePermissions(state, data) {
      state.currentRoutePermissions = data;
    },
    setSalesInvoicesGridTemplates(state, data) {
      state.invoicesGridTemplates = data;
    },
    setVats(state, payload) {
      state.invoiceVats = payload;
    },
    setComponentsVersions(state, data) {
      state.componentsVersions = data;
    },
    setInstancesTypes(state, data) {
      state.instances_types = data;
    }
  },
  actions: {
    async getCurrencies(store) {
      try {
        const data = await Vue.http.get('generic/currencies').then(handlerResponse);
        store.commit('getCurrencies', data);
      } catch (exception) {
        console.log(exception)
      }
    },
    async loadPackageTypes(store, payLoad) {
      try {
        const data = await Vue.http.get('generic/procpackagetypes', {params: payLoad}).then(handlerResponse);
        store.commit('setPackageTypes', data);
      } catch (exception) {
        console.log(exception)
      }
    },
    async loadIncoterms(store) {
      try {
        const data = await Vue.http.get('generic/incoterms').then(handlerResponse);
        store.commit('setIncoterms', data);
      } catch (exception) {
        console.log(exception);
      }
    },
    async loadNotificationsCount(store) {
      try {
        const data = await Vue.http.get('generic/notifications/count/').then(handlerResponse);
        store.commit('setNotificationsCount', data.count);
      } catch (exception) {
        console.log(exception);
      }
    },
    getGridTemplates(store, payload) {
      const params = {grid_name: payload};
      Vue.http.get('generic/pivot_grid_table_templates/', {params})
        .then(handlerResponse)
        .then(data => {
          if (payload === 'packets_search') {
            store.commit('setPacketsGridTemplates', data);
          } else if (payload === 'operations_search') {
            store.commit('setOperationsGridTemplates', data);
          } else if (payload === 'invoice_search') {
            store.commit('setSalesInvoicesGridTemplates', data);
          }
        })
    },
    loadVat(store) {
      Vue.http.get('generic/VAT')
        .then(handlerResponse)
        .then(data => {
          store.commit('setVat', data);
        });
    },
    loadCommissionTypes(store, agentRole = 'sale_agent') {
      Vue.http.get('generic/agent_commission_types/', {params: {role: agentRole}})
        .then(handlerResponse)
        .then(data => {
          store.commit('setCommissionTypes', data);
        });
    },
    async loadShapeType(store) {
      try {
        const data = await Vue.http.get('generic/shape_type/').then(handlerResponse);
        store.commit('setShapeType', data);
      } catch (exception) {
        console.log(exception);
      }
    },
    async loadGridTemplates(store, payLoad) {
      try {
        const params = {grid_name: payLoad};
        const data = await Vue.http.get('generic/pivot_grid_table_templates/', {params})
          .then(handlerResponse)
        if (payLoad === 'raw_distribution') {
          store.commit('setRawDistributionGridTemplates', data);
        }
      } catch (e) {
        console.log(e);
      }
    },
    loadLanguages(store) {
      Vue.http.get('generic/languages/')
        .then(handlerResponse)
        .then(data => {
          store.commit('setLanguages', data);
        });
    },
    async loadUserPermissions(store) {
      try {
        const data = await Vue.http.get('generic/get_user_perms/').then(handlerResponse)
        store.commit('setUserPermissions', data);
      } catch (e) {
        console.log(e);
      }
    },
    async getComponentsVersions({commit}) {
      try {
        const data = await Vue.http.get('generic/components_versions_json/').then(handlerResponse);
        commit('setComponentsVersions', data);
        return data;
      } catch (e) {
        console.log(e);
      }
    },
    loadVats({commit}) {
      return new Promise(resolve => {
        Vue.http.get(`generic/VAT`)
          .then(handlerResponse)
          .then(data => {
            commit('setVats', data);
            resolve(data);
          });
      });
    },
    async getInstancesTypes({commit}) {
      try {
        const data = await Vue.http.get('generic/attachment_related_instances_types/').then(handlerResponse);
        commit('setInstancesTypes', data);
      } catch (e) {
        console.error(e);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/generic.js